export default {
    data() {
        return {
            wd: "",
            pagination: {
                total: 0,
                per_page: 20,
                current_page: 1,
            },
            picker_options: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
        };
    },
    methods: {
        on_search() {
            this.$router.push(this.path + "?_search=1&wd=" + this.wd);
        },
        reset_query() {
            let query = this.$route.query;

            this.wd = Object.prototype.hasOwnProperty.call(query, "wd") ? query["wd"] : "";
        },
        handle_current_change(e) {
            this.$router.push({
                path: this.pageUrl,
                query: {
                    ...this.$route.query,
                    page: e,
                },
            });
        },
        handle_size_change(e) {
            this.$router.push({
                path: this.pageUrl,
                query: {
                    ...this.$route.query,
                    per_page: e,
                },
            });
        },
        redirect(e){
            window.open(e)
        },
        on_field_change(e, field) {
            let new_query = JSON.parse(JSON.stringify(this.$route.query));
            new_query[field] = e;
            this.$router.push(this.path + "?" + this.objectToQuery(new_query));
        },
    },
};
